import RestX from 'highered-utils/restx';
import { ListNodesFilter, ResourceNode } from './types/resources';

class ResourceService {
    static async getRootFolders(schoolId: number): Promise<{ data: ResourceNode[] }> {
        const root = 'root';

        return (
            ((RestX.getInterfaces() as any).resources.folder.id(root).get({
                organization: schoolId,
            }) as { data: ResourceNode[] }) || []
        );
    }

    static async getFolderById(
        schoolId: number,
        folderId: string
    ): Promise<{ data: ResourceNode[] }> {
        return (
            ((RestX.getInterfaces() as any).resources.folder.id(folderId).get({
                organization: schoolId,
            }) as { data: ResourceNode[] }) || []
        );
    }

    static async getFileById(folderId: string): Promise<{ data: ResourceNode }> {
        return (RestX.getInterfaces() as any).resources.nodes.id(folderId).get() as {
            data: ResourceNode;
        };
    }

    static async getRootFoldersBySchool(schoolId: number): Promise<{ data: ResourceNode[] }> {
        const params: ListNodesFilter = {
            organizations: [schoolId],
            systemResource: false,

            public: true,
        };

        return (RestX.getInterfaces() as any).resources.nodes.get({
            ...params,
        });
    }

    static async getRootSystemFolders(): Promise<{ data: ResourceNode[] }> {
        const params: ListNodesFilter = {
            systemResource: true,

            public: true,
        };

        return (RestX.getInterfaces() as any).resources.nodes.get({
            ...params,
        });
    }
}

export const HIGHERED_CV_TEMPLATE =
    'https://content.gethighered.global/miscellaneous/Highered_CV_Template.docx';

export default ResourceService;
